import React , { useEffect, useState} from 'react';
import {  useSelector} from 'react-redux';
import { cancellationPolicyReducerSelector } from '../../../selectors/cancellation-policy-selectors'; 
import { CancellationPolicyForm } from '../cancellation-policy-form-component/cancellation-policy-form.component';
import { useDispatch } from 'react-redux';
import { CancellationPolicyTable } from '../cancellation-policy-table/cancellation-policy.table';
import { getCancellationPolicyDetails } from '../../../actions/cancellation-policy.actions'

export const CancellationPolicyRootComponent = (props) => {

    const {
        defaultLoadAgents,
        operatorCode,
        loadData
    } = props;

    const [ formData,updateformData ] = useState({});
    const dispatch = useDispatch();

    const cancellationPolicyReducer = useSelector(cancellationPolicyReducerSelector)

    const {
        cancellationPolicy,
    } = useSelector(cancellationPolicyReducerSelector)

    const getCancellationPolicy=()=>{
        dispatch(getCancellationPolicyDetails())
      }

      useEffect(()=>{
        getCancellationPolicy();
      },[]);

    useEffect(()=>{
        if(defaultLoadAgents){
            loadData(operatorCode);
        }
    },[])

    return (
        <div>
            <CancellationPolicyTable
            {...cancellationPolicyReducer}
            dataSource={cancellationPolicy}
            formData={formData}
            updateformData={updateformData}
            />
            
                <CancellationPolicyForm
                {...cancellationPolicyReducer}
                formData={formData}
                updateformData={updateformData}
                operatorCode={operatorCode}
                />

        </div>
    );
}
